<template>
  <div class="author-detail" v-if="author">
    <slot name="header"></slot>
    <div class="author-item">
      <div class="row">
        <h1>{{author.firstName}} {{author.lastName}}</h1>
      </div>
      <div class="row">
        <h5>{{authorInfo.filter(Boolean).join(' / ')}}</h5>
      </div>
      <div class="row hidden-sm-up">
        <!--Mobile Only-->
        <div class="col p-0">
          <social-media-buttons :media-links="author.mediaLinks" class="social-media-buttons m-0"></social-media-buttons>
        </div>
        <div class="col-2">
          <a class="envelope" :href="`mailto:${author.email}`"><icon name="envelope-o"></icon></a>
        </div>
        <!--Mobile Only-->
      </div>
      <div class="row">
        <div class="col-md-4 col-12 mb-2"><img :src="getStaticPath(author.photoUrl ? 'img/temp/' + author.photoUrl : '')" /></div>
        <div class="col">
          {{author.description}}
          <!--Large-Device Only-->
          <div class="hidden-md-down">
            <social-media-buttons :media-links="author.mediaLinks" class="social-media-buttons"></social-media-buttons>
            <a class="button-primary" :href="`mailto:${author.email}`">Email Board author ></a>
            <a class="button-primary">Fields of Interest ></a>
          </div>
          <!--Large-Device Only-->
        </div>
      </div>
    </div>
    <title-block :id="'authorsIssues'" :title="`${siteName} Papers from this Author`" link-title="View All" link-name="" color-theme="primary-color">
      <div>
        <condensed-issue v-for="paper in authorsIssues" :key="paper.id" v-bind:issue="paper"></condensed-issue>
      </div>
    </title-block>
    <title-block :id="'top100Papers'" title="Top 100 Papers from the Editorial Board" link-title="View All" link-name="" color-theme="primary-color">
      <div>
        <condensed-issue v-for="paper in top100Papers" :key="paper.id" v-bind:issue="paper"></condensed-issue>
      </div>
    </title-block>
  </div>
</template>

<script>
  import TitleBlock from '@/components/shared/TitleBlockComponent'
  import UtilityMixin from '@/components/shared/mixins/UtilityMixin'
  import CondensedIssue from '@/components/shared/CondensedIssueComponent'
  import SocialMediaButtons from '@/components/main-layout/shared/SocialMediaButtonsComponent'

  export default {
    name: 'author-details',
    components: {
      SocialMediaButtons,
      CondensedIssue,
      TitleBlock
    },
    mixins: [UtilityMixin],
    props: {
      authorId: {
        default: function () {
          return this.$route.params ? this.$route.params.id : undefined
        }
      }
    },
    data () {
      return {
        author: {
          photoUrl: ''
        },
        authorInfo: [],
        top100Papers: [],
        authorsIssues: [],
        siteName: process.env.SITE_NAME
      }
    },
    created () {
      // TODO: replace service call for author details
      this.$http.get(this.$store.state.dataUrlMockFile).then(function (response) {
        this.author = response.body.editorsInChief[this.authorId]
      }, function () {
      })

      this.authorInfo = [this.author.location, this.author.education, this.author.affiliation, this.author.institution]

      this.$http.get(this.$store.state.dataUrlArticleList).then(function (response) {
        this.top100Papers = response.body.articles
      }, function () {
      })

      this.$http.get(this.$store.state.dataUrlArticleList).then(function (response) {
        this.authorsIssues = response.body.articles
      }, function () {
      })

      // event handler for 'view all' link
      this.$on('view-all', function (id) {
        if (id === 'top100Papers') {
          // show all
        } else if (id === 'authorsIssues') {
          // show all
        }
      })
    }
  }
</script>


<style scoped lang="scss">
  .author-detail {
    font-family: 'Open Sans', sans-serif;
    font-size: 14px;
    .author-item {
      margin:20px 20px 40px;
      h1{
        display: block;
      }
      h5{
        display: block;
        font-style: italic;
        font-size: 14px;
        padding: 10px 0;
        font-family: 'Open Sans Condensed', sans-serif;
      }
      img {
        width: 100%;
      }
      .social-media-buttons {
        display: block;
        margin: 20px 0;
      }
      a, a:hover {
        text-decoration: none;
        color: $white !important;
      }
      .envelope {
        color: inherit;
        margin-left: 10px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// AuthorDetailsComponent.vue?5504a348